module.exports = __webpack_public_path__ + "static/media/Hour_07-12.2c637120.png";